<h5>Add New View</h5>

<ul class="list-style-none border-one-pixel-solid no-bullet">
  @for (option of availableWidgetTypes; track option) {
    <li (click)="add(option)">{{option}}</li>
  }
</ul>
